import styled from 'styled-components';

import colors from 'styles/theme/colors';
import { LabelSmall } from 'styles/typography';

type Props = {
  text?: string;
  renderIcon?: () => React.ReactNode;
  $backgroundColor?: string;
  $color?: string;
  dataCy?: string;
};

export default function CardBadge({ text, renderIcon, $backgroundColor, $color, dataCy }: Props) {
  return (
    <Container $backgroundColor={$backgroundColor} $color={$color} $padding={!!text} data-cy={dataCy}>
      <IconContainer>{renderIcon && renderIcon()}</IconContainer>
      {text && <Text title={text}>{text}</Text>}
    </Container>
  );
}

const Container = styled.div<{ $backgroundColor?: string; $color?: string; $padding?: boolean }>`
  height: 24px;
  min-width: 24px;
  justify-content: center;
  padding: ${({ $padding }) => ($padding ? '0px 8px' : null)};
  display: flex;
  align-items: center;
  border-radius: ${({ theme }) => theme.dimensions.borderRadius};
  background: ${({ $backgroundColor }) => $backgroundColor || colors.black5};
  color: ${({ $color }) => $color || colors.black100};
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 12px;
  height: 12px;
`;

const Text = styled(LabelSmall)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-left: 8px;
`;
